module.exports = __webpack_public_path__ + "img/category_main_4.8398ab14.jpg";